// extracted by mini-css-extract-plugin
export default {"root":"styles_root__wf2W+","left":"styles_left__lbmYB","right":"styles_right__X2BHv","outlineButton":"styles_outlineButton__kL2XG"};